var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 474,
    height: 509,
    viewBox: "0 0 474 509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M228.087 28.053S371.496-5.44 362.991 187.484c-6.593 149.529 117.423 78.019 90.069 184.581-27.354 106.563-314.42 171.515-397.083-17.066-101.852-232.356 172.11-326.946 172.11-326.946Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F84FF",
    d: "M208.163 420.532C117.517 396.243 63.723 303.07 88.012 212.423 112.3 121.777 205.474 67.983 296.12 92.272c90.646 24.288 144.44 117.462 120.151 208.108-24.289 90.647-117.462 144.44-208.109 120.152Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape03);
export default __webpack_public_path__ + "static/media/shape03.9aa4c878f0b09783d93166e12db69346.svg";
export { ForwardRef as ReactComponent };